module.exports = __webpack_public_path__ + "img/img_left@3x.d31b4095.png";